import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import ExpenditBreakdownByActivitiesWidget from '../../../widgets/periodicFinancialReportSubProject/ExpenditBreakdownByActivitiesWidget'
import SummaryPeriodicExpensesWidget from '../../../widgets/periodicFinancialReportSubProject/SummaryPeriodicExpensesWidget'
import {
  Button,
  Col,
  ControlLabel,
  Icon,
  IconButton,
  Message,
  Modal,
  Panel,
  Radio,
  RadioGroup,
  Row,
  Uploader,
} from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { RETRY_CONTACT_ADMIN } from '../../../constants/msgText'
import PdfRenderWidgets from '../../../widgets/pdfWidgets/PdfRenderWidgets'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'
import InputForm from '../../../components/forms/input/InputForm'
import EditButton from '../../../components/buttons/editButton/EditButton'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { isRequired, isValidators } from '../../../utils/ValidatorUtils'
import classNames from 'classnames'
import AppContext from '../../../context/AppContext'

export default function PeriodicFinancialReport() {
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const [error, setError] = useState()
  const [schemas, setSchemas] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isPdfError, setIsPdfError] = useState(false)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)
  const [showVerifyConfirm, setShowVerifyConfirm] = useState(false)
  const [showTransferInstallmentPaymentConfirm, setShowTransferInstallmentPaymentConfirm] =
    useState(false)
  const [showApproveConfirm, setShowApproveConfirm] = useState(false)
  const [showWithdrawConfirm, setShowWithdrawConfirm] = useState(false)
  const { theme } = React.useContext(AppContext)
  const [approveTypeVal, setApproveTypeVal] = useState(null)
  const [approveWithdrawTypeVal, setApproveWithdrawTypeVal] = useState(null)
  const [show, setShow] = useState(false)
  let progressId = location.search.substring(1)

  const mockSchema = {
    header: 'รายงานการเงินครั้งที่ 1',
    subHeader: 'รหัสโครงการ 65-10063-01 : รณรงลดโรค ลดโควิด 09/01',
    forms: {
      projectActivity: {
        header: 'ส่วนที่ 1 แบบแจกแจงรายจ่ายแยกตามกิจกรรมโครงการ',
        // taxBankInput: {
        //   name: 'taxBankInput',
        //   label: 'ภาษีดอกเบี้ยรับธนาคาร (ถ้ามี)',
        //   unit: 'บาท',
        //   value: '',
        //   validators: null,
        // },
        // otherExpensesInput: {
        //   name: 'otherExpensesInput',
        //   label: 'ค่าใช้จ่ายอื่นๆ (ถ้ามี)',
        //   placeholder: '- ระบุ -',
        //   value: '',
        //   validators: null,
        // },
        withdrawInput: {
          name: 'withdrawInput',
          label: 'ถอนเงินเปิดบัญชีธนาคาร',
          unit: 'บาท',
          placeholder: '0.00',
          value: '0.00',
          validators: null,
        },
        // otherExpensesPriceInput: {
        //   name: 'otherExpensesPriceInput',
        //   label: '',
        //   value: '',
        //   unit: 'บาท',
        //   validators: null,
        // },
        values: [
          {
            id: 'xxxx-xxxx-01',
            activity: 'กิจกรรมที่ 1',
            compensation: 1500, //ค่าตอบแทน
            wages: 900, //ค่าจ้าง
            expenses: 18200, //ค่าใช้สอย
            materialCost: 700, //ค่าวัสดุ
            utilityCosts: 550, //ค่าสาธารณูปโภค
            otherExpenses: 1200, //รายจ่ายอื่นๆ
            total: 23050,
          },
          {
            id: 'xxxx-xxxx-02',
            activity: 'กิจกรรมที่ 2',
            compensation: 2000, //ค่าตอบแทน
            wages: 3000, //ค่าจ้าง
            expenses: 2000, //ค่าใช้สอย
            materialCost: 2000, //ค่าวัสดุ
            utilityCosts: 0, //ค่าสาธารณูปโภค
            otherExpenses: 0, //รายจ่ายอื่นๆ
            total: 9000,
          },
          {
            id: 'xxxx-xxxx-03',
            activity: 'กิจกรรมที่ 3',
            compensation: 18000, //ค่าตอบแทน
            wages: 0, //ค่าจ้าง
            expenses: 2000, //ค่าใช้สอย
            materialCost: 0, //ค่าวัสดุ
            utilityCosts: 0, //ค่าสาธารณูปโภค
            otherExpenses: 0, //รายจ่ายอื่นๆ
            total: 20000,
          },
          {
            id: 'total',
            activity: '',
            compensation: 21500, //ค่าตอบแทน
            wages: 3900, //ค่าจ้าง
            expenses: 22200, //ค่าใช้สอย
            materialCost: 2700, //ค่าวัสดุ
            utilityCosts: 550, //ค่าสาธารณูปโภค
            otherExpenses: 1200, //รายจ่ายอื่นๆ
            total: 52050,
          },
        ],
      },
      summaryPeriodicExpenses: {
        header: 'ส่วนที่ 2 แบบรายงานสรุปการใช้จ่ายเงินประจำงวดนี้',
        income: {
          title: '1. รายรับ',
          input: [
            {
              name: 'carryingBalance',
              label: 'เงินคงเหลือยกมา (ถ้ามี)',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'ssoBalance',
              label: 'เงินรับจาก สสส. งวด นี้',
              value: '50000.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'interestReceivable',
              label: 'ดอกเบี้ยรับ',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
            {
              name: 'bankAccOpeningMoney',
              label: 'เงินเปิดบัญชีธนาคาร',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
            {
              name: 'total',
              label: 'รวมรายรับ',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
          ],
        },
        expenses: {
          title: '2. รายจ่าย',
          input: [
            {
              name: 'periodNegativeBalance',
              label: 'ยอดติดลบงวดก่อนหน้ายกมา (ถ้ามี)',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'activity0',
              label: 'กิจกรรมที่ 1',
              value: '2000.00',
              unit: 'บาท',
              placeholder: '0',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'activity1',
              label: 'กิจกรรมที่ 2',
              value: '1600.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'activity2',
              label: 'กิจกรรมที่ 3',
              value: '14000.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            // {
            //   name: 'bankInterestTax',
            //   label: 'ภาษีดอกเบี้ยรับธนาคาร',
            //   value: '0.00',
            //   unit: 'บาท',
            //   placeholder: '0.00',
            //   disable: true,
            //   validators: null,
            //   information: null,
            // },
            {
              name: 'withdrawMoneyBankAccount',
              label: 'ถอนเงินเปิดบัญชีธนาคาร',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
            {
              name: 'total',
              label: 'รวมรายจ่าย',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
          ],
        },
        balance: {
          title: '3. คงเหลือ',
          input: [
            {
              name: 'moneyOnhand',
              label: 'เงินสดในมือ',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'bankDeposits',
              label: 'เงินฝากในบัญชีธนาคาร',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: 'ยอดเงินสุดท้ายที่ปรากฏในบัญชีธนาคาร',
            },
            {
              name: 'total',
              label: '(1) รายรับ - (2) รายจ่าย = (3)',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
          ],
        },
        attachFiles: {
          name: 'attachFiles',
          header: 'แนบสำเนาสมุดบัญชีเงินฝากธนาคาร',
          buttonText: 'ไฟล์ประกอบการติดตาม',
          fileSize: 50,
          fileType: '.jpg, .jpeg, .png, .pdf',
          description: ['แนบสำเนาสมุดบัญชีเงินฝากธนาคาร'],
          value: [
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
          ],
          id: null,
        },
      },
      notedInput: {
        name: 'notedInput',
        label: 'กรุณาระบุข้อความเพื่อขอส่งรายงาน และเบิกเงินงวด กับทีมสนับสนุน (ถ้ามี)',
        value: '',
        validators: null,
      },
      button: {
        buttonSave: 'บันทึก',
        buttonApprove: 'ส่งรายการ ขอเบิกเงินงวด',
        buttonSendBlack: null,
      },
    },
  }

  const mockSchema2 = {
    header: 'รายงานการเงินครั้งที่ 1 ',
    subHeader: 'รหัสโครงการ 65-10063-01 : รณรงลดโรค ลดโควิด 09/01',
    forms: {
      projectActivity: {
        header: 'ส่วนที่ 1 แบบแจกแจงรายจ่ายแยกตามกิจกรรมโครงการ',
        // taxBankInput: {
        //   name: 'taxBankInput',
        //   label: 'ภาษีดอกเบี้ยรับธนาคาร (ถ้ามี)',
        //   unit: 'บาท',
        //   value: '',
        //   validators: null,
        // },
        // otherExpensesInput: {
        //   name: 'otherExpensesInput',
        //   label: 'ค่าใช้จ่ายอื่นๆ (ถ้ามี)',
        //   placeholder: '- ระบุ -',
        //   value: '',
        //   validators: null,
        // },
        withdrawInput: {
          name: 'withdrawInput',
          label: 'ถอนเงินเปิดบัญชีธนาคาร',
          placeholder: '0.00',
          value: '0.00',
          unit: 'บาท',
          validators: null,
        },
        // otherExpensesPriceInput: {
        //   name: 'otherExpensesPriceInput',
        //   label: '',
        //   value: '',
        //   unit: 'บาท',
        //   validators: null,
        // },
        values: [
          {
            id: 'xxxx-xxxx-01',
            activity: 'กิจกรรมที่ 1',
            compensation: 1500, //ค่าตอบแทน
            wages: 900, //ค่าจ้าง
            expenses: 18200, //ค่าใช้สอย
            materialCost: 700, //ค่าวัสดุ
            utilityCosts: 550, //ค่าสาธารณูปโภค
            otherExpenses: 1200, //รายจ่ายอื่นๆ
            total: 23050,
          },
          {
            id: 'xxxx-xxxx-02',
            activity: 'กิจกรรมที่ 2',
            compensation: 2000, //ค่าตอบแทน
            wages: 3000, //ค่าจ้าง
            expenses: 2000, //ค่าใช้สอย
            materialCost: 2000, //ค่าวัสดุ
            utilityCosts: 0, //ค่าสาธารณูปโภค
            otherExpenses: 0, //รายจ่ายอื่นๆ
            total: 9000,
          },
          {
            id: 'xxxx-xxxx-03',
            activity: 'กิจกรรมที่ 3',
            compensation: 18000, //ค่าตอบแทน
            wages: 0, //ค่าจ้าง
            expenses: 2000, //ค่าใช้สอย
            materialCost: 0, //ค่าวัสดุ
            utilityCosts: 0, //ค่าสาธารณูปโภค
            otherExpenses: 0, //รายจ่ายอื่นๆ
            total: 20000,
          },
          {
            id: 'total',
            activity: '',
            compensation: 21500, //ค่าตอบแทน
            wages: 3900, //ค่าจ้าง
            expenses: 22200, //ค่าใช้สอย
            materialCost: 2700, //ค่าวัสดุ
            utilityCosts: 550, //ค่าสาธารณูปโภค
            otherExpenses: 1200, //รายจ่ายอื่นๆ
            total: 52050,
          },
        ],
      },
      summaryPeriodicExpenses: {
        header: 'ส่วนที่ 2 แบบรายงานสรุปการใช้จ่ายเงินประจำงวดนี้',
        income: {
          title: '1. รายรับ',
          input: [
            {
              name: 'carryingBalance',
              label: 'เงินคงเหลือยกมา (ถ้ามี)',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'ssoBalance',
              label: 'เงินรับจาก สสส. งวด นี้',
              value: '50000.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'interestReceivable',
              label: 'ดอกเบี้ยรับ',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
            {
              name: 'bankAccOpeningMoney',
              label: 'เงินเปิดบัญชีธนาคาร',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
            {
              name: 'total',
              label: 'รวมรายรับ',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
          ],
        },
        expenses: {
          title: '2. รายจ่าย',
          input: [
            {
              name: 'periodNegativeBalance',
              label: 'ยอดติดลบงวดก่อนหน้ายกมา (ถ้ามี)',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'activity0',
              label: 'กิจกรรมที่ 1',
              value: '2000.00',
              unit: 'บาท',
              placeholder: '0',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'activity1',
              label: 'กิจกรรมที่ 2',
              value: '1600.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'activity2',
              label: 'กิจกรรมที่ 3',
              value: '14000.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            // {
            //   name: 'bankInterestTax',
            //   label: 'ภาษีดอกเบี้ยรับธนาคาร',
            //   value: '0.00',
            //   unit: 'บาท',
            //   placeholder: '0.00',
            //   disable: true,
            //   validators: null,
            //   information: null,
            // },
            {
              name: 'withdrawMoneyBankAccount',
              label: 'ถอนเงินเปิดบัญชีธนาคาร',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
            {
              name: 'total',
              label: 'รวมรายจ่าย',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
          ],
        },
        balance: {
          title: '3. คงเหลือ',
          input: [
            {
              name: 'moneyOnhand',
              label: 'เงินสดในมือ',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: true,
              validators: null,
              information: null,
            },
            {
              name: 'bankDeposits',
              label: 'เงินฝากในบัญชีธนาคาร',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: 'ยอดเงินสุดท้ายที่ปรากฏในบัญชีธนาคาร',
            },
            {
              name: 'total',
              label: '(1) รายรับ - (2) รายจ่าย = (3)',
              value: '0.00',
              unit: 'บาท',
              placeholder: '0.00',
              disable: false,
              validators: null,
              information: null,
            },
          ],
        },
        attachFiles: {
          name: 'attachFiles',
          header: 'แนบสำเนาสมุดบัญชีเงินฝากธนาคาร',
          buttonText: 'ไฟล์ประกอบการติดตาม',
          fileSize: 50,
          fileType: '.jpg, .jpeg, .png, .pdf',
          description: ['แนบสำเนาสมุดบัญชีเงินฝากธนาคาร'],
          value: [
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
          ],
          id: null,
        },
      },
      notedInput: {
        name: 'notedInput',
        label: 'กรุณาระบุข้อความเพื่อส่งกลับแก้ไข',
        value: '',
        validators: null,
      },
      attachFiles: {
        name: 'attachFiles',
        header: 'กรุณาแนบเอกสารประกอบโอนเงิน',
        buttonText: 'ไฟล์เอกสารประกอบโอนเงิน',
        fileSize: 50,
        fileType: '.jpg, .jpeg, .png, .pdf',
        description: ['แนบเอกสารประกอบโอนเงิน'],
        value: [
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
          {
            seqNo: 1,
            isUpSeqNo: true,
            isDownSeqNo: false,
            label: 'ไฟล์ทดสอบ.png',
            name: 'ไฟล์ทดสอบ.png',
            path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
            type: null,
            size: 0,
            id: '030CF477-509D-494A-8226-BF870998E63B',
          },
        ],
        id: null,
      },
      buttonApproveInstallmentPayment: {
        notedInput: {
          name: 'notedInput',
          label: 'ความเห็นเพิ่มเติมอื่นๆ',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกลักษณะนวัตกรรม',
            },
          ],
        },
        approveType: {
          name: 'approveType',
          label: 'ความเห็นต่อคำขอเบิกเงินงวด',
          value: '',
          options: [
            {
              disabled: false,
              label: 'เห็นควรเบิกจ่ายเงินงวดถัดไป',
              value: 1,
            },
            {
              disabled: false,
              label: 'เห็นควรเบิกจ่ายเงินงวดและปิดโครงการ',
              value: 2,
            },
            {
              disabled: false,
              label: 'เห็นควรเบิกจ่ายเงินงวดและยุติโครงการ',
              value: 3,
            },
          ],
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอก',
            },
          ],
        },
        financialSigning: {
          name: 'financialSigning',
          label: 'การลงนามในรายงานการเงิน',
          value: '',
          options: [
            {
              disabled: false,
              label: 'แบบกระดาษ',
              value: 1,
            },
            {
              disabled: false,
              label: 'แบบอิเล็กทรอนิกส์',
              value: 2,
            },
          ],
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอก',
            },
          ],
        },
      },
      buttonRequestInstallmentPayment: {
        notedInput: {
          name: 'notedInput',
          label: 'ความเห็นเพิ่มเติมอื่นๆ',
          value: '',
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกความเห็นเพิ่มเติมอื่นๆ',
            },
          ],
        },
        approveType: {
          name: 'approveType',
          label: '',
          value: '',
          options: [
            {
              disabled: false,
              label: 'ขอเบิกจ่ายเงินงวดถัดไป',
              value: 1,
            },
            {
              disabled: false,
              label: 'ขอปิดโครงการ',
              value: 2,
            },
            {
              disabled: false,
              label: 'ขอยุติโครงการ',
              value: 3,
            },
          ],
          validators: [
            {
              type: 'REQUIRED',
              value: null,
              errorMessage: 'กรุณากรอกลักษณะนวัตกรรม',
            },
          ],
        },
        attachFiles: {
          name: 'attachFiles',
          header: 'กรุณาแนบเอกสารประกอบขอเบิกเงินงวด',
          buttonText: 'ไฟล์เอกสารประกอบขอเบิกเงินงวด',
          fileSize: 50,
          fileType: '.jpg, .jpeg, .png, .pdf',
          description: ['แนบเอกสารประกอบขอเบิกเงินงวด'],
          value: [
            {
              seqNo: 1,
              isUpSeqNo: true,
              isDownSeqNo: false,
              label: 'ไฟล์ทดสอบ.png',
              name: 'ไฟล์ทดสอบ.png',
              path: 'proposal/appendix/45CC61FF-C595-4CA3-BAE2-63CC97F315FF.png',
              type: null,
              size: 0,
              id: '030CF477-509D-494A-8226-BF870998E63B',
            },
          ],
          id: null,
        },
      },
      button: {
        buttonSave: null,
        buttonApprove: null,
        buttonRequestInstallmentPayment: 'ส่งรายงานขอเบิกเงินงวด',
        buttonApproveInstallmentPayment: 'อนุมัติเบิกเงินงวด',
        buttonTransferInstallmentPayment: 'โอนจ่ายเงินงวด',
        buttonSendBlack: 'ส่งกลับแก้ไข',
      },
    },
  }

  useEffect(() => {
    console.log('progressId', progressId)
    if (progressId == '38060D9A') {
      //ภาคี
      setSchemas(mockSchema)
    } else {
      setSchemas(mockSchema2)
    }
  }, [progressId])

  if (error) {
    return (
      <SidebarProposal isSubProjectDep6>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal isSubProjectDep6>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  console.log(
    'schemas.forms.buttonApproveInstallmentPayment => ',
    schemas.forms.buttonApproveInstallmentPayment
  )

  return (
    <>
      <SidebarProposal isSubProjectDep6>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        <ExpenditBreakdownByActivitiesWidget schema={schemas.forms.projectActivity} />

        <br />

        <SummaryPeriodicExpensesWidget schema={schemas.forms.summaryPeriodicExpenses} />

        <br />

        {isPdfError ? (
          <Message showIcon type="error" description={'ไม่พบไฟล์ PDF  ' + RETRY_CONTACT_ADMIN} />
        ) : (
          <>
            <PdfRenderWidgets
              file={previewPdf}
              isLoading={isLoadingPDF}
              isShaded={true}
              // onReload={() => handleGetProjectSubmitPdf(projectId)}
              loadingMessage="กรุณารอสักครู่ ระบบกำลังสร้าง PDF ข้อเสนอโครงการ..."
              firstExpandToReload
            />
          </>
        )}

        {schemas.forms.button && (
          <>
            <div
              style={{
                zIndex: 101,
                position: 'sticky',
                bottom: 0,
                left: 0,
                width: '100%',
                textAlign: 'right',
                marginTop: 20,
              }}
            >
              <Panel shaded bodyFill>
                <div style={{ marginTop: 10 }}>
                  {schemas.forms.button.buttonRequestInstallmentPayment && (
                    <>
                      <SaveButton
                        icon="send"
                        onClick={() => {
                          setShowWithdrawConfirm(true)
                          setShow(false)
                          setApproveWithdrawTypeVal(null)
                        }}
                      >
                        {schemas.forms.button.buttonRequestInstallmentPayment}
                      </SaveButton>
                    </>
                  )}

                  {schemas.forms.button.buttonApproveInstallmentPayment && (
                    <>
                      <SaveButton
                        icon="send"
                        onClick={() => {
                          setShowApproveConfirm(true)
                          setShow(false)
                          setApproveTypeVal(null)
                        }}
                      >
                        {schemas.forms.button.buttonApproveInstallmentPayment}
                      </SaveButton>
                    </>
                  )}

                  {schemas.forms.button.buttonTransferInstallmentPayment && (
                    <>
                      <SaveButton
                        onClick={() => {
                          setShowTransferInstallmentPaymentConfirm(true)
                        }}
                        icon="exchange"
                      >
                        {schemas.forms.button.buttonTransferInstallmentPayment}
                      </SaveButton>
                    </>
                  )}

                  {schemas.forms.button.buttonApprove && (
                    <>
                      <IconButton
                        appearance="ghost"
                        style={{
                          marginRight: 10,
                          marginBottom: 10,
                        }}
                        icon={
                          <Icon appearance="ghost" icon={'send'} className="bt-gost-icon-radius" />
                        }
                      >
                        {schemas.forms.button.buttonApprove}
                      </IconButton>
                    </>
                  )}

                  {schemas.forms.button.buttonSendBlack && (
                    <>
                      <EditButton
                        icon="send"
                        onClick={() => {
                          setShowVerifyConfirm(true)
                        }}
                        // disabled={isLoading}
                      >
                        {schemas.forms.button.buttonSendBlack}
                      </EditButton>
                    </>
                  )}
                </div>
              </Panel>
            </div>
          </>
        )}

        {/* ส่งรายงานขอเบิกเงินงวด */}
        <Modal
          show={showWithdrawConfirm}
          onHide={() => {
            // setShowVerifyConfirm(false)
            // setShowTransferInstallmentPaymentConfirm(false)
            setShowWithdrawConfirm(false)
          }}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>
              {/* {schemas?.forms?.buttonRequestInstallmentPayment?.header || ''} */}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {schemas.forms.buttonRequestInstallmentPayment && (
              <>
                <Row style={{ marginTop: 40 }}>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                  <Col lg={20} md={20} sm={20} xs={20}>
                    {show && <Message showIcon type="error" description="กรุณาเลือก 1 รายการ" />}

                    <Controller
                      name={schemas.forms.buttonRequestInstallmentPayment.approveType.name}
                      control={control}
                      defaultValue={
                        schemas.forms.buttonRequestInstallmentPayment.approveType.value || '1'
                      }
                      rules={isValidators(
                        schemas.forms.buttonRequestInstallmentPayment.approveType.validators
                      )}
                      render={(props) => {
                        return (
                          <RadioGroup
                            value={props.value}
                            onChange={(value) => {
                              props.onChange(value)
                              setApproveWithdrawTypeVal(value)
                              setShow(false)
                            }}
                          >
                            {schemas.forms.buttonRequestInstallmentPayment.approveType.options.map(
                              (item) => (
                                <Radio
                                  key={item.value}
                                  value={item.value}
                                  disabled={
                                    schemas.forms.buttonRequestInstallmentPayment.approveType
                                      .disabled
                                  }
                                >
                                  {item.label}
                                </Radio>
                              )
                            )}
                          </RadioGroup>
                        )
                      }}
                    />
                  </Col>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                </Row>
                <Row style={{ marginTop: 20 }}>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                  <Col lg={20} md={20} sm={20} xs={20}>
                    <InputForm
                      schema={schemas.forms.buttonRequestInstallmentPayment.notedInput}
                      // value={item.link}
                      register={register}
                      // placeholder={formSchema.otherExpensesInput.placeholder}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      hideLabel={true}
                      componentClass={'textarea'}
                    />
                  </Col>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                </Row>
                {(approveWithdrawTypeVal == 2 || approveWithdrawTypeVal == 3) && (
                  <Row style={{ marginTop: 40 }}>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                    <Col lg={20} md={20} sm={20} xs={20}>
                      <ErrorMessage
                        error={
                          errors[schemas.forms.buttonRequestInstallmentPayment.notedInput.name]
                        }
                      />
                      {/* <ControlLabel
                  className={classNames(
                    isRequired(schemas.forms.buttonRequestInstallmentPayment.notedInput.validators) && 'required'
                  )}
                >
                  {schemas.forms.buttonRequestInstallmentPayment.notedInput.header}
                </ControlLabel> */}
                      <Controller
                        key={schemas.forms.buttonRequestInstallmentPayment.notedInput.name}
                        name={schemas.forms.buttonRequestInstallmentPayment.notedInput.name}
                        control={control}
                        rules={isValidators(
                          schemas.forms.buttonRequestInstallmentPayment.notedInput.validators
                        )}
                        defaultValue={''}
                        render={(props) => {
                          return (
                            <Uploader
                              accept={
                                schemas.forms.buttonRequestInstallmentPayment.notedInput.fileType ||
                                '.jpg, .jpeg, .png, .pdf'
                              }
                              autoUpload={false}
                              disabled={
                                schemas.forms.buttonRequestInstallmentPayment.notedInput.disabled
                              }
                              fileListVisible={true}
                              listType="picture-text"
                              fileList={props.value || []}
                              // onChange={(fileList) => {
                              //   if (isEmpty(fileList)) {
                              //     props.onChange(undefined)
                              //   } else {
                              //     let file = fileList[fileList.length - 1]

                              //     if(file.blobFile.size > (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024){
                              //       notification.open('error', {
                              //         title:
                              //           `ขนาดไฟล์เกิน ${schemas.forms.buttonRequestInstallmentPayment.notedInput.fileSize || defaultMaxFileSize} MB`,
                              //         duration: 5000,
                              //       })
                              //       return
                              //     }

                              //     if (isImageOrPdf(file.blobFile.type)) {
                              //       props.onChange(fileList)
                              //       setFileTypeError(false)
                              //     } else {
                              //       setFileTypeError(true)
                              //       notification.open('error', {
                              //         title:
                              //           'ชนิดที่รองรับ ' + schemas.forms.buttonRequestInstallmentPayment.notedInput.fileType ||
                              //           '.jpg, .jpeg, .png, .pdf',
                              //         duration: 5000,
                              //       })
                              //     }
                              //   }
                              // }}
                              draggable
                            >
                              <div>
                                <div
                                  style={{ lineHeight: '50px' }}
                                  className={classNames('uploader', `${theme[0]}-background`)}
                                >
                                  <Icon size="4x" icon="upload2" />
                                  <small className="uploder__text">
                                    <p
                                      style={{ wordBreak: 'break-word' }}
                                      dangerouslySetInnerHTML={{
                                        __html: `คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf <b>ขนาดไม่เกิน 20 Mb</b>`,
                                      }}
                                    />
                                  </small>
                                </div>
                              </div>
                            </Uploader>
                          )
                        }}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                if (!approveWithdrawTypeVal) {
                  setShow(true)
                  return false
                  // approveTypeVal(null)
                }
                setShowWithdrawConfirm(false)
              }}
              appearance="primary"
            >
              ยืนยัน
            </Button>
            <Button
              onClick={() => {
                setShowWithdrawConfirm(false)
              }}
              appearance="subtle"
              style={{ backgroundColor: '#EEB187', color: '#fff' }}
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>

        {/* อนุมัติเบิกเงินงวด */}
        <Modal
          show={showApproveConfirm}
          onHide={() => {
            // setShowVerifyConfirm(false)
            // setShowTransferInstallmentPaymentConfirm(false)
            setShowApproveConfirm(false)
          }}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>
              {/* {schemas?.forms?.buttonApproveInstallmentPayment?.header || ''} */}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {schemas.forms.buttonApproveInstallmentPayment && (
              <>
                <Row style={{ marginTop: 40 }}>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                  <Col lg={20} md={20} sm={20} xs={20}>
                    <b>{schemas.forms.buttonApproveInstallmentPayment.approveType.label}</b>
                  </Col>
                </Row>
                <Row>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                  <Col lg={20} md={20} sm={20} xs={20}>
                    {show && <Message showIcon type="error" description="กรุณาเลือก 1 รายการ" />}

                    <Controller
                      name={schemas.forms.buttonApproveInstallmentPayment.approveType.name}
                      control={control}
                      defaultValue={
                        schemas.forms.buttonApproveInstallmentPayment.approveType.value || '1'
                      }
                      rules={isValidators(
                        schemas.forms.buttonApproveInstallmentPayment.approveType.validators
                      )}
                      render={(props) => {
                        return (
                          <RadioGroup
                            value={props.value}
                            onChange={(value) => {
                              props.onChange(value)
                              setApproveTypeVal(value)
                              setShow(false)
                            }}
                          >
                            {schemas.forms.buttonApproveInstallmentPayment.approveType.options.map(
                              (item) => (
                                <Radio
                                  key={item.value}
                                  value={item.value}
                                  disabled={
                                    schemas.forms.buttonApproveInstallmentPayment.approveType
                                      .disabled
                                  }
                                >
                                  {item.label}
                                </Radio>
                              )
                            )}
                          </RadioGroup>
                        )
                      }}
                    />
                  </Col>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                </Row>
                <Row style={{ marginTop: 10 }}>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                  <Col lg={20} md={20} sm={20} xs={20}>
                    <b>{schemas.forms.buttonApproveInstallmentPayment.financialSigning.label}</b>
                  </Col>
                </Row>
                <Row>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                  <Col lg={20} md={20} sm={20} xs={20}>
                    {show && <Message showIcon type="error" description="กรุณาเลือก 1 รายการ" />}

                    <Controller
                      name={schemas.forms.buttonApproveInstallmentPayment.financialSigning.name}
                      control={control}
                      defaultValue={
                        schemas.forms.buttonApproveInstallmentPayment.financialSigning.value || '1'
                      }
                      rules={isValidators(
                        schemas.forms.buttonApproveInstallmentPayment.financialSigning.validators
                      )}
                      render={(props) => {
                        return (
                          <RadioGroup
                            value={props.value}
                            onChange={(value) => {
                              props.onChange(value)
                              setApproveTypeVal(value)
                              setShow(false)
                            }}
                          >
                            {schemas.forms.buttonApproveInstallmentPayment.financialSigning.options.map(
                              (item) => (
                                <Radio
                                  key={item.value}
                                  value={item.value}
                                  disabled={
                                    schemas.forms.buttonApproveInstallmentPayment.financialSigning
                                      .disabled
                                  }
                                >
                                  {item.label}
                                </Radio>
                              )
                            )}
                          </RadioGroup>
                        )
                      }}
                    />
                  </Col>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                </Row>
                <Row style={{ marginTop: 20 }}>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                  <Col lg={20} md={20} sm={20} xs={20}>
                    <InputForm
                      schema={schemas.forms.buttonApproveInstallmentPayment.notedInput}
                      // value={item.link}
                      register={register}
                      // placeholder={formSchema.otherExpensesInput.placeholder}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      hideLabel={true}
                      componentClass={'textarea'}
                    />
                  </Col>
                  <Col lg={2} md={2} sm={2} xs={2}></Col>
                </Row>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                if (!approveTypeVal) {
                  setShow(true)
                  return false
                  // approveTypeVal(null)
                }
                setShowApproveConfirm(false)
              }}
              appearance="primary"
            >
              บันทึก
            </Button>
            <Button
              onClick={() => {
                if (!approveTypeVal) {
                  setShow(true)
                  return false
                  // approveTypeVal(null)
                }
                setShowApproveConfirm(false)
              }}
              appearance="primary"
              className="bt-gost-icon-radius-info"
            >
              ส่งลงนามอิเล็กทรอนิกส์
            </Button>
            <Button
              onClick={() => {
                setShowApproveConfirm(false)
              }}
              appearance="subtle"
              style={{ backgroundColor: '#EEB187', color: '#fff' }}
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>

        {/* โอนจ่ายเงินงวด */}
        <Modal
          show={showTransferInstallmentPaymentConfirm}
          onHide={() => {
            // setShowVerifyConfirm(false)
            setShowTransferInstallmentPaymentConfirm(false)
          }}
          size="lg"
        >
          <Modal.Header>
            <Modal.Title>{schemas?.forms?.attachFiles?.header || ''}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {schemas.forms.attachFiles && (
              <Row style={{ marginTop: 40 }}>
                <Col lg={2} md={2} sm={2} xs={2}></Col>
                <Col lg={20} md={20} sm={20} xs={20}>
                  <ErrorMessage error={errors[schemas.forms.attachFiles.name]} />
                  {/* <ControlLabel
                  className={classNames(
                    isRequired(schemas.forms.attachFiles.validators) && 'required'
                  )}
                >
                  {schemas.forms.attachFiles.header}
                </ControlLabel> */}
                  <Controller
                    key={schemas.forms.attachFiles.name}
                    name={schemas.forms.attachFiles.name}
                    control={control}
                    rules={isValidators(schemas.forms.attachFiles.validators)}
                    defaultValue={''}
                    render={(props) => {
                      return (
                        <Uploader
                          accept={schemas.forms.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                          autoUpload={false}
                          disabled={schemas.forms.attachFiles.disabled}
                          fileListVisible={true}
                          listType="picture-text"
                          fileList={props.value || []}
                          // onChange={(fileList) => {
                          //   if (isEmpty(fileList)) {
                          //     props.onChange(undefined)
                          //   } else {
                          //     let file = fileList[fileList.length - 1]

                          //     if(file.blobFile.size > (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024){
                          //       notification.open('error', {
                          //         title:
                          //           `ขนาดไฟล์เกิน ${schemas.forms.attachFiles.fileSize || defaultMaxFileSize} MB`,
                          //         duration: 5000,
                          //       })
                          //       return
                          //     }

                          //     if (isImageOrPdf(file.blobFile.type)) {
                          //       props.onChange(fileList)
                          //       setFileTypeError(false)
                          //     } else {
                          //       setFileTypeError(true)
                          //       notification.open('error', {
                          //         title:
                          //           'ชนิดที่รองรับ ' + schemas.forms.attachFiles.fileType ||
                          //           '.jpg, .jpeg, .png, .pdf',
                          //         duration: 5000,
                          //       })
                          //     }
                          //   }
                          // }}
                          draggable
                        >
                          <div>
                            <div
                              style={{ lineHeight: '50px' }}
                              className={classNames('uploader', `${theme[0]}-background`)}
                            >
                              <Icon size="4x" icon="upload2" />
                              <small className="uploder__text">
                                <p
                                  style={{ wordBreak: 'break-word' }}
                                  dangerouslySetInnerHTML={{
                                    __html: `คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .jpg, .jpeg, .png, .pdf <b>ขนาดไม่เกิน 20 Mb</b>`,
                                  }}
                                />
                              </small>
                            </div>
                          </div>
                        </Uploader>
                      )
                    }}
                  />
                </Col>
                <Col lg={2} md={2} sm={2} xs={2}></Col>
              </Row>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                setShowTransferInstallmentPaymentConfirm(false)
              }}
              appearance="primary"
            >
              ยืนยัน
            </Button>
            <Button
              onClick={() => {
                setShowTransferInstallmentPaymentConfirm(false)
              }}
              appearance="subtle"
              style={{ backgroundColor: '#EEB187', color: '#fff' }}
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ส่งกลับแก้ไข */}
        <Modal
          show={showVerifyConfirm}
          onHide={() => {
            setShowVerifyConfirm(false)
          }}
        >
          <Modal.Header>
            <Modal.Title>{schemas.forms.notedInput.label}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <InputForm
              schema={schemas.forms.notedInput}
              // value={item.link}
              register={register}
              // placeholder={formSchema.otherExpensesInput.placeholder}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel={true}
              componentClass={'textarea'}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                setShowVerifyConfirm(false)
              }}
              appearance="primary"
            >
              ยืนยัน
            </Button>
            <Button
              onClick={() => {
                setShowVerifyConfirm(false)
              }}
              appearance="subtle"
              style={{ backgroundColor: '#EEB187', color: '#fff' }}
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>

        {/* <ConfirmWidget
          size="md"
          title={`ยืนยัน${schemas.forms.button.buttonApprove}`}
          show={showVerifyConfirm}
          detail={`กรุณาระบุข้อความเพื่อขอส่งรายงาน และเบิกเงินงวด กับทีมสนับสนุน (ถ้ามี)`}
          onCancle={() => setShowVerifyConfirm(false)}
          onConfirm={() => {
            setShowVerifyConfirm(false)
            // handleProposalProjectSubmitVerify(request)
          }}
        /> */}

        <br />
      </SidebarProposal>
    </>
  )
}
